module.exports = __webpack_public_path__ + "img/logoCadastroPerfil.53b7759c.svg";